import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiPencil, mdiPlus } from "@mdi/js";
import { ModalChiTiet } from "./ModalChiTiet";

import iconChiTietDonHang from "Resources/ImagesNew/IconTable/iconChiTietDonHang.png";

export const BtnChiTiet = ({ item }) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const toggleModal = () => {
    //Start
    if (!isModalVisible === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    //End
    setModalVisible(!isModalVisible);
  };
  return (
    <>
      <a
        href={() => false}
        class="iconTable-Main iconW18"
        onClick={toggleModal}
      >
        {item.OrderCode}
        {/* <img src={iconChiTietDonHang} title="Chi tiết đơn hàng" alt="" /> */}
      </a>
      {isModalVisible && (
        <ModalChiTiet
          toggleModal={toggleModal}
          orderCode={item.OrderCode}
          item={item}
        />
      )}
    </>
  );
};
